import { render } from "./UserHeader.vue?vue&type=template&id=27979558"
import script from "./UserHeader.vue?vue&type=script&lang=js"
export * from "./UserHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__